import {makeObservable} from 'mobx';

import type {ID, Nullable, UUID} from '../../../utils/utility-types';
import type {CourseModel} from '../Course/Course.model';
import type {DateTimeModel} from '../Date/DateTime.model';

import {BaseModel} from '../Base/Base.model';

const ModelName = 'TaskModel';

export class TaskModel extends BaseModel {
  baseTaskId: Nullable<ID>;
  clientId: ID;
  coachTaskId: Nullable<ID>;
  course: Nullable<CourseModel>;
  description: string;
  endDate: DateTimeModel;
  isBaseTask: boolean;
  isClientTask: boolean;
  isCoachTask: boolean;
  isMeCoach: boolean;
  startDate: DateTimeModel;
  status: TaskModel.Status;
  title: string;
  uuid: UUID;

  constructor(props: TaskModel.Props) {
    super(props);
    Object.assign(this, props);

    makeObservable(
      this,
      BaseModel.mobxAnnotationFactory<TaskModel, TaskModel.Props>(props),
    );
  }

  static override get modelName(): typeof ModelName {
    return ModelName;
  }

  get modelName(): typeof ModelName {
    return ModelName;
  }
}

export namespace TaskModel {
  export type Props = BaseModel.ModelToProps<TaskModel>;

  export type Status = 'done' | 'frozen' | 'pending' | 'suspended';
}
